// Color helper utilities extracted from OfferPageBuilderSimple.js
// Lines 150-282

// Helper function to get inline color arrays for background colors
export const getInlineBackgroundColors = (isBrandsPage) => {
  if (isBrandsPage) {
    return [
      { name: 'Blue', value: '#2630f3' },
      { name: 'Yellow', value: '#e7cb16' },
      { name: 'Pink', value: '#eabbc3' },
      { name: 'Black', value: '#101022' },
      { name: 'White', value: '#ffffff' },
      { name: 'Transparent', value: 'transparent' }
    ];
  }
  return [
    // Full color array for Setups page
    { name: 'None', value: 'transparent' },
    { name: 'White', value: '#ffffff' },
    { name: 'Black', value: '#101022' },
    { name: 'Light Gray', value: '#f5f5f5' },
    { name: 'Gray', value: '#9e9e9e' },
    { name: 'Dark Gray', value: '#424242' },
    { name: 'Light Blue', value: '#e3f2fd' },
    { name: 'Blue', value: '#2630f3' },
    { name: 'Dark Blue', value: '#1976d2' },
    { name: 'Light Green', value: '#e8f5e8' },
    { name: 'Green', value: '#4caf50' },
    { name: 'Dark Green', value: '#388e3c' },
    { name: 'Light Red', value: '#ffebee' },
    { name: 'Red', value: '#f44336' },
    { name: 'Dark Red', value: '#d32f2f' },
    { name: 'Light Orange', value: '#fff3e0' },
    { name: 'Orange', value: '#ff9800' },
    { name: 'Dark Orange', value: '#f57c00' },
    { name: 'Light Purple', value: '#f3e5f5' },
    { name: 'Purple', value: '#9c27b0' },
    { name: 'Dark Purple', value: '#7b1fa2' },
    { name: 'Light Pink', value: '#fce4ec' },
    { name: 'Pink', value: '#eabbc3' },
    { name: 'Dark Pink', value: '#c2185b' },
    { name: 'Light Yellow', value: '#fffde7' },
    { name: 'Yellow', value: '#e7cb16' },
    { name: 'Dark Yellow', value: '#fbc02d' },
    { name: 'Light Teal', value: '#e0f2f1' },
    { name: 'Teal', value: '#009688' },
    { name: 'Dark Teal', value: '#00695c' },
    { name: 'Light Brown', value: '#efebe9' },
    { name: 'Brown', value: '#795548' },
    { name: 'Dark Brown', value: '#5d4037' }
  ];
};

// Helper function to get inline color arrays for text colors
export const getInlineTextColors = (isBrandsPage) => {
  if (isBrandsPage) {
    return [
      { name: 'Blue', value: '#2630f3' },
      { name: 'Yellow', value: '#e7cb16' },
      { name: 'Pink', value: '#eabbc3' },
      { name: 'Black', value: '#101022' },
      { name: 'White', value: '#ffffff' }
    ];
  }
  return [
    // Full color array for Setups page
    { name: 'Black', value: '#101022' },
    { name: 'Dark Gray', value: '#424242' },
    { name: 'Gray', value: '#757575' },
    { name: 'Light Gray', value: '#9e9e9e' },
    { name: 'White', value: '#ffffff' },
    { name: 'Blue', value: '#1976d2' },
    { name: 'Light Blue', value: '#42a5f5' },
    { name: 'Dark Blue', value: '#0d47a1' },
    { name: 'Green', value: '#388e3c' },
    { name: 'Light Green', value: '#66bb6a' },
    { name: 'Dark Green', value: '#1b5e20' },
    { name: 'Red', value: '#d32f2f' },
    { name: 'Light Red', value: '#ef5350' },
    { name: 'Dark Red', value: '#b71c1c' },
    { name: 'Orange', value: '#f57c00' },
    { name: 'Light Orange', value: '#ff9800' },
    { name: 'Dark Orange', value: '#e65100' }
  ];
};

// Helper function to get the current font family for an element
export const getCurrentFontFamily = (element, subElement = null) => {
  if (subElement && element.type === 'BUTTON_WITH_NOTICE') {
    return element.subElementStyles?.[subElement]?.fontFamily || 'inherit';
  }

  // If fontFamily is explicitly set, use it
  if (element.styles?.fontFamily) {
    return element.styles.fontFamily;
  }

  // Try to detect font family based on element type and existing styles
  const { fontSize, fontWeight, fontStyle } = element.styles || {};

  // Map common style combinations to likely font families
  if (fontSize === '32px' && fontWeight === 400) {
    return "'Gilroy-Heavy', sans-serif";
  }
  if (fontSize === '18px' && fontWeight === 700) {
    return "'Poppins', sans-serif";
  }
  if (fontSize === '20px' && fontWeight === 400) {
    return "'Gilroy-Black', sans-serif";
  }
  if (fontSize === '18px' && fontWeight === 400) {
    return "'Gilroy-Medium', sans-serif";
  }
  if (fontSize === '16px' && fontWeight === 400) {
    return "'Gilroy-Medium', sans-serif";
  }
  if (fontSize === '14px' && fontWeight === 500) {
    return "'Akatab', sans-serif";
  }
  if (fontSize === '16px' && fontWeight === 700 && fontStyle === 'italic') {
    return "'Jost', sans-serif";
  }
  if (fontSize === '12px' && fontWeight === 700) {
    return "'Open Sans', sans-serif";
  }
  if (fontSize === '14px' && fontWeight === 700) {
    return "'Geist', sans-serif";
  }

  // Default to inherit if no specific font can be determined
  return 'inherit';
};
